import React from 'react'

// Generic form field with consistent label, spacing, and input styling
export const FormField = React.memo(({ label, required = false, hint, error, children }) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label} {required && <span className="text-red-600">*</span>}
        </label>
      )}
      {children}
      {hint && !error && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  )
})

FormField.displayName = 'FormField';

export const TextInput = React.memo((props) => {
  const { className = '', ...rest } = props
  return (
    <input
      {...rest}
      className={`w-full h-10 px-3 rounded-lg border border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${className}`}
    />
  )
})

TextInput.displayName = 'TextInput';

export const SelectInput = React.memo(({ children, className = '', ...rest }) => {
  return (
    <select
      {...rest}
      className={`w-full h-10 px-3 rounded-lg border border-gray-300 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${className}`}
    >
      {children}
    </select>
  )
})

SelectInput.displayName = 'SelectInput';

export const TextAreaInput = React.memo(({ className = '', rows = 3, ...rest }) => {
  return (
    <textarea
      {...rest}
      rows={rows}
      className={`w-full px-3 py-2 rounded-lg border border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${className}`}
    />
  )
})

TextAreaInput.displayName = 'TextAreaInput';

export const DateInput = React.memo((props) => {
  return <TextInput type="date" {...props} />
})

DateInput.displayName = 'DateInput';

export const NumberWithUnit = React.memo(({ value, onChange, name, placeholder, unit = '', min, max, step }) => {
  return (
    <div className="relative">
      <TextInput
        type="number"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step || 'any'}
        className="pr-12"
      />
      {unit && (
        <span className="absolute inset-y-0 right-3 flex items-center text-xs text-gray-500 select-none">{unit}</span>
      )}
    </div>
  )
})

NumberWithUnit.displayName = 'NumberWithUnit';

export default FormField

